import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import { loadState, saveState } from '../utils';
import sagas from './saga';

import commonReducer from './slices/common';
import authReducer from './slices/auth';
import creditReport from './slices/credit-report';
import leadsReducer from './slices/leads';
import hyperReducer from './slices/hyperverge';
import lenderReducer from './slices/lenders';
import { baseApi } from './baseApi';
import { setupListeners } from '@reduxjs/toolkit/query';

const sagaMiddleware = createSagaMiddleware();
const preloadedState = loadState();

const rootReducer = combineReducers({
  authReducer,
  creditReport,
  leadsReducer,
  commonReducer,
  hyperReducer,
  lenderReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

const store: any = configureStore({
  reducer: rootReducer,
  preloadedState,
  middleware: (getDefaultMiddleware) => {
    const middleware: any = getDefaultMiddleware({
      thunk: true,
      serializableCheck: false,
    });
    middleware.push(baseApi.middleware);
    middleware.push(sagaMiddleware);
    if (process.env.NODE_ENV === 'development') {
      middleware.push(logger);
    }
    return middleware;
  },
});

store.subscribe(() => {
  saveState({
    authReducer: store.getState().authReducer,
    creditReport: store.getState().creditReport,
    lenderReducer: store.getState().lenderReducer,
    leadsReducer: store.getState().leadsReducer,
    commonReducer: store.getState().commonReducer,
    hyperReducer: store.getState().hyperReducer,
  });
});

sagaMiddleware.run(sagas);
setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
